import UnreadMessagesCount from './UnreadMessagesCount'

const AllConversationsUnreadMessagesCount = UnreadMessagesCount

export default AllConversationsUnreadMessagesCount
